export default "__VITE_ASSET__BFDMOKKx__"